import { requireField } from './validators';

export default class Document {
  constructor(data = {}) {
    requireField(data.name, 'document.name');

    this.id = data.id || `doc-${Math.random().toString(36).slice(2, 9)}`;
    this.name = data.name;
    this.tags = data.tags || [];
    this.visibility = data.visibility || ['Admin', 'Manager', 'Staff'];
    this.versions = data.versions || [];
    this.metadata = data.metadata || {};
    this.dueDate = data.dueDate || data.metadata?.dueDate || null;
    this.expiryDate = data.expiryDate || data.metadata?.expiryDate || null;
    this.notes = data.notes || '';
  }

  toJSON() {
    return { ...this };
  }
}
